import { Mods, mods } from '@approvalmax/theme';
import { font, TransparentButton, uTextEllipsis } from '@approvalmax/ui';
import { ui } from 'modules/common';
import styled from 'styled-components';

export const RemoveWatcherButton = styled(TransparentButton)`
    flex: none;
    margin-right: 6px;
    fill: #eaeaea;
    background: #a3a2a2;
    transition:
        opacity 150ms,
        background 150ms,
        visibility 200ms;
    opacity: 0;
    border-radius: 50%;
    padding: 3px;
    line-height: 0;

    &:hover {
        background: #ee6f3a;
        fill: #fff;
    }
`;

export const StyledWatcherItem = styled.div<Mods<'readOnly'>>`
    flex: none;
    display: flex;
    align-items: center;

    &:hover ${RemoveWatcherButton} {
        opacity: 1;
    }

    ${mods.readOnly.true`
        opacity: 0.5;
    `}
`;

export const WatcherAvatar = styled(ui.Avatar)`
    cursor: pointer;
    flex: none;
`;

export const WatcherName = styled.div`
    ${font(13, '#30373d')};
    ${uTextEllipsis};
    margin-left: 6px;
    margin-right: 6px;
    cursor: pointer;
`;
